// Section detail-card table, ported from menu_test/sections/sub_items.coffee SectionCardView
// (getDetailRows + renderDetailTable): 7 fixed rows, '...' values and a bare 'N' header while
// the per-section answer is loading.

import { formatAmounts } from '@aytm/app/stats/lib/util/helpers'

import { formatSeconds } from '@aytm/app/stats/page/question-views/mn/lib/format'
import { purchasedCount } from '@aytm/app/stats/page/question-views/mn/lib/viewOptions'

const AMOUNT_TITLE = 'Section purchase amount'
const OPENED_TITLE = 'Respondents opened section'
const PURCHASED_TITLE = 'Respondents purchased from section'

const fmt = (v, decimals = 2) => Math.round(v * Math.pow(10, decimals)) / Math.pow(10, decimals) || 0

export const getDetailRows = (answer, priceTemplate, hasPrice, isLoading, questionTotal = 0) => {
  // the currency is whatever the price mask carries around the number; a bare mask adds no suffix
  const currency = hasPrice && priceTemplate ? priceTemplate.replace(/{{price}}/gi, '').trim() : ''
  const amountTitle = currency ? `${AMOUNT_TITLE}, ${currency}` : AMOUNT_TITLE

  if (isLoading) {
    return [
      { title: OPENED_TITLE, value: '...' },
      { title: PURCHASED_TITLE, value: '...' },
      { title: 'Purchase quantity', value: '...' },
      { title: amountTitle, value: '...' },
      { title: 'Attention span', value: '...' },
      { title: 'Time to first click', value: '...' },
      { title: 'Time to order', value: '...' }
    ]
  }

  const opened = fmt(answer.amount || 0, 0)
  const openedPercents = fmt(answer.percents || 0, 1)

  const pVolume = fmt(answer.pVolume || 0)
  const pAmount = fmt(answer.pAmount || 0)
  const pAmountStr = hasPrice ? priceTemplate.replace(/{{price}}/gi, pAmount) : 'N/A'

  const purchased = fmt(purchasedCount(answer), 0)
  const purchasedPercents = fmt(questionTotal ? (purchased / questionTotal) * 100 : 0, 1)

  const attention = fmt(answer.attention || 0)
  const timeToFirstClick = fmt(answer.timeToFirstClick || 0)
  const time = fmt(answer.time || 0)

  return [
    { title: OPENED_TITLE, value: `${opened} (${openedPercents}%)` },
    { title: PURCHASED_TITLE, value: `${purchased} (${purchasedPercents}%)` },
    { title: 'Purchase quantity', value: pVolume },
    { title: amountTitle, value: pAmountStr },
    { title: 'Attention span', value: formatSeconds(attention) },
    { title: 'Time to first click', value: formatSeconds(timeToFirstClick) },
    { title: 'Time to order', value: formatSeconds(time) }
  ]
}

// the base N is question-level; per-section answers carry no `total`
export const calcSectionCardTable = ({ questionId, position, answer, priceTemplate, questionTotal = 0 } = {}) => {
  const resolvedAnswer = answer || {}
  const hasPrice = null != priceTemplate
  const isLoading = 'loading' === resolvedAnswer

  return {
    id: `${questionId}-sq${position}-detail`,
    cols: [
      { type: 'title', title: 'Description' },
      {
        type: 'value',
        width: 160,
        title: isLoading ? 'N' : `N <small>(from ${formatAmounts(questionTotal)} resp.)</small>`
      }
    ],
    rows: getDetailRows(resolvedAnswer, priceTemplate, hasPrice, isLoading, questionTotal).map((row, i) => ({
      cells: [{ title: row.title }, { value: row.value }],
      position: i + 1
    }))
  }
}
